import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import { store } from '@giscube/geoportal-ee';
export default store;